import { useContext } from 'react';
import { AuthContext } from '~/contexts';
import {
  validateUserPermissions,
  validateUserRole,
} from '~/utils/validateUserPermissions';
import { UseCanParams, UseRoleCanParams } from './types';

export function useCan({ accessTypes = [] }: UseCanParams): boolean {
  const { user, isStorageValid } = useContext(AuthContext);

  if (!isStorageValid) {
    return false;
  }

  const userHasValidPermissions = validateUserPermissions({
    user,
    accessTypes,
  });

  return userHasValidPermissions;
}

export function useRoleCan({ roles = [] }: UseRoleCanParams): boolean {
  const { user, isStorageValid } = useContext(AuthContext);

  if (!isStorageValid) {
    return false;
  }

  const userHasValidRolePermissions = validateUserRole({
    user,
    roles,
  });

  return userHasValidRolePermissions;
}

export function useExternoCan({ roles = [] }: UseRoleCanParams): boolean {
  const { user, isStorageValid } = useContext(AuthContext);

  if (!isStorageValid) {
    return false;
  }

  const userHasValidRolePermissions = validateUserRole({
    user,
    roles,
  });

  return userHasValidRolePermissions && user?.responsavel;
}

export function useIsComissioned(): boolean {
  const { user, isStorageValid } = useContext(AuthContext);

  if (!isStorageValid) {
    return false;
  }

  return user?.comissionado;
}

export function useIsCustomerSuccess(): boolean {
  const { user, isStorageValid } = useContext(AuthContext);

  if (!isStorageValid) {
    return false;
  }

  return user?.customer_success;
}

export function useViewCommission(): boolean {
  const { user, isStorageValid } = useContext(AuthContext);

  if (!isStorageValid) {
    return false;
  }

  return user?.visualizar_comissao;
}

export function useIsInternal(): boolean {
  const { user, isStorageValid } = useContext(AuthContext);

  if (!isStorageValid) {
    return false;
  }

  return user?.type === 'Interno';
}

export function useIsExternal(): boolean {
  const { user, isStorageValid } = useContext(AuthContext);

  if (!isStorageValid) {
    return false;
  }

  return user?.type === 'Externo';
}
